module.exports = __webpack_public_path__ + "static/media/whiteCrossIcon.36d3867f.svg";